import PropTypes from 'prop-types';
import { useRef, useState, useEffect } from 'react';

function Draggable({ rootClass = '', children }) {
  const ourRef = useRef(null);
  const [isMouseDown, setIsMouseDown] = useState(false);
  const mouseCoords = useRef({
    startX: 0,
    startY: 0,
    scrollLeft: 0,
    scrollTop: 0,
  });

  const handleDragEnd = () => {
    setIsMouseDown(false);
    document.body.style.cursor = 'default';
  };

  useEffect(() => {
    window.addEventListener('mouseup', handleDragEnd);
    return () => {
      window.removeEventListener('mouseup', handleDragEnd);
    };
  }, []);

  const handleDragStart = (e) => {
    if (!ourRef.current) return;
    const slider = ourRef.current.children[0];
    const startX = e.pageX - slider.offsetLeft;
    const startY = e.pageY - slider.offsetTop;
    const { scrollLeft, scrollTop } = slider;
    mouseCoords.current = { startX, startY, scrollLeft, scrollTop };
    setIsMouseDown(true);
    document.body.style.cursor = 'grabbing';
  };

  const handleDrag = (e) => {
    if (!isMouseDown || !ourRef.current) return;
    e.preventDefault();
    const slider = ourRef.current.children[0];
    const x = e.pageX - slider.offsetLeft;
    const y = e.pageY - slider.offsetTop;
    const walkX = (x - mouseCoords.current.startX) * 1.5;
    const walkY = (y - mouseCoords.current.startY) * 1.5;
    slider.scrollLeft = mouseCoords.current.scrollLeft - walkX;
    slider.scrollTop = mouseCoords.current.scrollTop - walkY;
  };

  return (
    <div ref={ourRef} onMouseDown={handleDragStart} onMouseMove={handleDrag} className={`${rootClass} flex overflow-x-scroll`}>
      {children}
    </div>
  );
}

Draggable.propTypes = {
  rootClass: PropTypes.string,
  children: PropTypes.node,
};

export default Draggable;
